import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import HBText from '../../honeybook-ui/HBText/HBText';
import {
    FeatureBlockSection,
    FeatureBlockContent
} from '../../FeatureBlockElements';
import RegistrationForm from '../../RegistrationForm/RegistrationForm';
import HBMediaElement from '../../honeybook-ui/HBMediaElement/HBMediaElement';
import './home-hero-new.scss';

const HomeHeroNew = () => {
    const { t } = useTranslation();
    const breakpoints = useBreakpoint();

    return (
        <FeatureBlockSection customClass="home-hero-new">
            <FeatureBlockContent>
                <div className="home-hero-new__text-content">
                    <HBMediaElement
                        customClass="home-hero-new__image home-hero-new__squiggle1"
                        name="marketing_site/home_page/hero/squiggle1.png"
                        lazyLoad={false}
                    />
                    <HBMediaElement
                        customClass="home-hero-new__image home-hero-new__squiggle2"
                        name="marketing_site/home_page/hero/squiggle2.png"
                        lazyLoad={false}
                    />
                    <HBMediaElement
                        customClass="home-hero-new__image home-hero-new__plane"
                        name="marketing_site/home_page/hero/plane.png"
                        lazyLoad={false}
                    />
                    <HBText
                        tag="h1"
                        type="title-l"
                        customClass="home-hero-new__title"
                    >
                        {t('homeHero.title')}
                    </HBText>

                    <HBText
                        tag="h2"
                        type="body-l"
                        customClass="home-hero-new__subtitle"
                    >
                        {t('homeHero.subtitle')}
                    </HBText>
                    <RegistrationForm
                        source="homepage hero"
                        showNoCcRequired
                        size={breakpoints.medium ? 'medium' : 'large'}
                        buttonText={t('homeHero.ctaText')}
                    />
                </div>
                <div className="home-hero-new__media-content">
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        poster="https://res.cloudinary.com/honeybook/image/upload/v1747168624/marketing_site/home_page/hero/hero-poster.png"
                        className="hbui-video"
                        controls={false}
                    >
                        <source
                            src="https://res.cloudinary.com/honeybook/video/upload/v1747168328/marketing_site/home_page/hero/home-hero2.mp4"
                            type="video/mp4"
                        />
                        <source
                            src="https://res.cloudinary.com/honeybook/video/upload/v1747168328/marketing_site/home_page/hero/home-hero2.webm"
                            type="video/webm"
                        />
                        <source
                            src="https://res.cloudinary.com/honeybook/video/upload/v1747168328/marketing_site/home_page/hero/home-hero2.ogv"
                            type="video/ogg"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </FeatureBlockContent>
        </FeatureBlockSection>
    );
};

export default memo(HomeHeroNew);
